import { Component, OnInit , Input} from '@angular/core';
import { DataElement } from '../../../core/models/data-element.model';
import { ChoiceDataElement } from '../../../core/elements/models/choice-data-element-model';
import { DomSanitizer } from '@angular/platform-browser';

declare var require: any;

@Component({
  selector: 'acr-image-map',
  template: `<div class="col-sm-8">
  <label class="control-label font-weight-400">Not sure? try out this image </label>
  <button type="button" class="btn btn-default" data-toggle="modal" attr.data-target="#{{'imgMap_Modal_'+DataElement.id}}">
    <span class="glyphicon glyphicon-picture" aria-hidden="true" data-toggle="tooltip" data-placement="top" title="Image Map"></span>
  </button>
</div>
<ng-container *ngIf="imagePath != undefined">
  <div class="modal inmodal fade" id="{{'imgMap_Modal_'+DataElement.id}}" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">Close</span>
          </button>
          <h4 class="modal-title"> {{SelectionValue}}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <ng-container *ngIf="imageExist == true">
                  <img class="ImgOption danger img-responsive max-w-h-100" alt="{{ DataElement.imageMap.label }}" data-dismiss="modal" attr.id="{{'imgMap_Img_'+DataElement.id}}"
                    (click)="imageClick($event,DataElement);" attr.data-elementID="{{DataElement.id}}" attr.usemap="#{{'imgMap_'+DataElement.id}}"
                    [src]="domSanitizer.bypassSecurityTrustUrl(getImageDataUrl(DataElement.imageMap.location))">
                <map name="{{'imgMap_'+DataElement.id}}">
                  <ng-container *ngFor="let imgOpt of DataElement.imageMap.map.areas">
                    <area attr.shape="{{imgOpt.shape}}" attr.imgID="{{'imgMap_Img_'+DataElement.id}}" attr.coords="{{imgOpt.coords}}"
                      attr.alt="{{imgOpt.choiceValue}}" (mouseover)='displayValue(imgOpt.choiceValue);' (mouseout)='displayValue("");'
                      (click)="setValue(imgOpt.choiceValue);" data-dismiss="modal">
                  </ng-container>
                </map>
              </ng-container>
              <ng-container *ngIf="imageExist == false">
                <div class="">
                  No Image Map Available...
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
`,
  styles: [``, `.required-field{color:red}.padding-l-5{padding-left:5px}.whitespace{margin-left:5px}.max-w-h-100{max-width:100%;max-height:100%}.carousel-control>.fa{font-size:40px;position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-20px}.carousel-control.left{background-repeat:repeat-x}.carousel-control.left,.carousel-control.right{background-image:none}.carousel-control.right{background-image:linear-gradient(to right,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-repeat:repeat-x}.scroll{overflow-y:scroll;overflow-x:hidden}.div-simulator-form-height{height:calc(100vh - 100px);overflow-y:scroll;overflow-x:hidden}.div-report-text-scroll{overflow-x:hidden;overflow-y:auto;max-height:calc(100vh - 300px)}.padding-r-10{padding-right:10px}.slide-left{left:30px}.slide-right{right:30px}hr{margin-top:10px;margin-bottom:10px}.white-space-line{white-space:pre-line;word-wrap:break-word}p{margin:0 0 10px}.form-control{border-radius:0;box-shadow:none;border-color:#d2d6de}h4.modal-title.float-left{float:left}.margin-b-0{margin-bottom:0}.font-weight-400{font-weight:400}.custom-radio-style{float:left;margin-right:15px}.zoom{width:100%;overflow:auto}.zoom img{height:auto;width:100%;min-width:100%;max-width:inherit!important}.btn-zoom{background-color:#f4f4f4;color:#444;border-color:#ddd}.btn-zoom.hover,.btn-zoom:active,.btn-zoom:hover{background-color:#e7e7e7}@media (min-width:768px){label.control-label{padding-left:20px}}.padding-5{padding:5px}`]
})

export class ImageMapComponent  implements OnInit {
    $ = require('jquery');
    @Input() DataElement: ChoiceDataElement;
    @Input() DataElements: Object = {};
    @Input() FormValues: Object = {};
    @Input() imagePath: string;
    isDataURL = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;
    domSanitizer: DomSanitizer;
    imageExist = true;
    SelectionValue = '';

    constructor(domSanitizer: DomSanitizer) {
        this.domSanitizer = domSanitizer;
    }

    ngOnInit() {

        if (this.DataElement === undefined) {
            return;
        }
        this.displayValue('');
    }

    isInRectangle(mouseX, mouseY, Coordinates) {
        const COArray = Coordinates.split(',');
        if (COArray[0] < mouseX
            && (COArray[0] + COArray[2]) > mouseX
            && COArray[1] < mouseY
            && (COArray[1] + COArray[3]) > mouseY) {
            return true;
        }
        return false;
    }

    isInCircle(mouseX, mouseY, Coordinates) {
        const COArray = Coordinates.split(',');
        if (Math.sqrt(Math.pow((mouseX - COArray[0]), 2) + Math.pow((mouseY - COArray[1]), 2)) < COArray[2]) {
            return true;
        } else {
            return false;
        }
    }

    isInPolygon(x, y, Coordinates) {
        const COArray = Coordinates.split(',');
        const vs = [];
        for (let i = 0; i < COArray.length; i++) {
            const point = [];
            point.push(COArray[i]);
            point.push(COArray[i + 1]);
            i += 1;
            vs.push(point);
        }
        let inside = false;
        for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
            const xi = vs[i][0], yi = vs[i][1];
            const xj = vs[j][0], yj = vs[j][1];
            const intersect = ((yi > y) !== (yj > y))
                && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) {
                inside = !inside;
            }
        }
        return inside;
    }

    imageClick(e, dataElement) {
        const O_height = dataElement.ImageProp.height;
        const O_width = dataElement.ImageProp.width;
        const $elem = this.$(e.target);

        const N_height = $elem.height();
        const N_width = $elem.width();


        const offset = $elem.offset();

        const offset_t = offset.top - this.$(window).scrollTop();
        const offset_l = offset.left - this.$(window).scrollLeft();

        const x = e.clientX - offset_l;
        const y = e.clientY - offset_t;
        for (const opt of dataElement.ImageOptions) {
            if (opt.Shape === 'rect') {
                if (this.isInRectangle(x, y, opt.Coordinates)) {
                    this.FormValues[dataElement.ID] = opt.Value;
                    break;
                }
            } else if (opt.Shape === 'circle') {
                if (this.isInCircle(x, y, opt.Coordinates)) {
                    this.FormValues[dataElement.ID] = opt.Value;
                    break;
                }
            } else if (opt.Shape === 'poly') {
                if (this.isInPolygon(x, y, opt.Coordinates)) {
                    this.FormValues[dataElement.ID] = opt.Value;
                    break;
                }
            }

        }

    }

    setValue(val) {
        for (const optValue of this.DataElement.choiceInfo) {
            if (this.DataElement.choiceInfo.length <= 5 && this.DataElement.choiceInfo.length > 0) {
                if (optValue.value === val) {
                    this.$('#' + val + '_' + this.DataElement.id).prop('checked', true);
                    const customEvent = document.createEvent('Event');
                    customEvent.initEvent('change', true, true);
                    this.$('#' + val + '_' + this.DataElement.id)[0].dispatchEvent(customEvent);
                } else {
                    this.$('#' + optValue.value + '_' + this.DataElement.id).prop('checked', false);
                }
            } else {
                if (optValue.value === val) {
                    this.$('#' + this.DataElement.id).val(optValue.value);
                    const customEvent = document.createEvent('Event');
                    customEvent.initEvent('change', true, true);
                    this.$('#' + this.DataElement.id)[0].dispatchEvent(customEvent);
                    break;
                }
            }
        }
        this.DataElement.currentValue = val;
        // this.FormValues[this.DataElement.id] = val;
    }

    displayValue(val) {
        if (val === '') {
            this.SelectionValue = 'Image Map Diagram';
        } else {
            this.SelectionValue = 'Selected Value : ' + val;
        }
    }

    getImageDataUrl(location: string): string {
        const isDataURL = !!location.match(this.isDataURL);
        if (isDataURL) {
        location = location.replace('unsafe:', '');
          return location;
        } else {
          return this.imagePath + '/' + location;
        }
      }
    }
